/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Closing_CtaInputs */

const en_platform_closing_cta = /** @type {(inputs: Platform_Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your page`)
};

const pl_platform_closing_cta = /** @type {(inputs: Platform_Closing_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz swoją stronę`)
};

/**
* | output |
* | --- |
* | "Create your page" |
*
* @param {Platform_Closing_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_closing_cta = /** @type {((inputs?: Platform_Closing_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Closing_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_closing_cta(inputs)
	return en_platform_closing_cta(inputs)
});